export default __webpack_public_path__ + "static/media/modal-close-white-icon.c27af825.svg";